// extracted by mini-css-extract-plugin
export default {"titleName":"contactInfo_titleName__F6OcF","inputBox":"contactInfo_inputBox__Fo2ii"};